import type { RouteSeoEntry } from '@/config/seo';

/**
 * The single source of truth for indexable routes. The sitemap, the prerender
 * (out/<path>/index.html) and the client-side meta all read this map, so a route that is
 * missing here is not in the sitemap and is not prerendered.
 * Rules (enforced by config/seo.test.ts): unique title <= 60 chars, unique description
 * 70-160 chars, paths without a trailing slash ("/" for home). Copy comes from each page's text.
 */
export const seoMeta: Record<string, RouteSeoEntry> = {
  '/': {
    title: 'Chronic Care Management Solutions | Chronicity Health',
    description:
      'Chronic care management combining medical expertise, behavioral health, nutrition and pharmacy services for measurable outcomes and revenue growth.',
  },
  '/contact': {
    title: 'Schedule a Demo | Chronicity Health',
    description:
      'Schedule a demo of our care management programs. Call (844) 422-6633 or email info@setupccm.com; our team replies within 24 hours.',
  },
  '/programs/ccm': {
    title: 'Chronic Care Management (CCM) Services | Chronicity Health',
    description:
      'Coordinated Medicare Chronic Care Management for patients with two or more chronic conditions: care plans, 24/7 care team access and medication management.',
  },
  '/programs/rpm': {
    title: 'Remote Patient Monitoring (RPM) | Chronicity Health',
    description:
      'Real-time health tracking with FDA-approved connected devices, so the care team can detect changes early and intervene before conditions worsen.',
  },
  '/programs/bhi': {
    title: 'Behavioral Health Integration (BHI) | Chronicity Health',
    description:
      'Mental health and substance use disorder services integrated with primary care, with licensed therapists, psychiatric specialists and care coordinators.',
  },
  '/programs/tcm': {
    title: 'Transitional Care Management (TCM) | Chronicity Health',
    description:
      'Support from hospital to home: TCM begins within 48 hours of discharge with medication reconciliation, follow-up appointments and ongoing monitoring.',
  },
  '/programs/pcm': {
    title: 'Principal Care Management (PCM) | Chronicity Health',
    description:
      'Intensive care coordination for patients with a single high-risk chronic condition, such as advanced heart failure or severe COPD requiring oxygen.',
  },
};
